import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {API_TYPES} from "../../../core/consts";

export class EntityDescriptionRequestParams extends BaseApiRequestParams {
  sportType: Number;
  entityType: Number;
  entityId: Number;
  prefix: String;
  apiType: API_TYPES;

  constructor(prefix: String, apiType: API_TYPES, entityId: Number, entityType: Number, sportType: Number, sectionNames: String, activateLinks: Boolean = true) {
    super('');

    this.usePrefix = false;
    this.prefix = prefix;
    this.apiType = apiType;
    this.entityId = entityId;
    this.entityType = entityType;
    this.sportType = sportType;
    this.sectionNames = sectionNames;
    this.activateLinks = activateLinks;
  }

  get fullUrl(): String {
    const url: String = `${this.prefix}${this.toString()}`;

    return url;
  }

  get apiTypeParam() {
    return this.apiType ? `&apiType=${this.apiType}` : '';
  }

  get entityIdParam() {
    return this.entityId ? `&entityId=${this.entityId}` : '';
  }

  get entityTypeParam() {
    return this.entityType >= 0 ? `&entityType=${this.entityType}` : '';
  }

  get sportTypeParam() {
    return this.sportType ? `&sportType=${this.sportType}` : '';
  }

  get sectionNamesParam() {
    return this.sectionNames ? `&sectionNames=${this.sectionNames}` : '';
  }

  get activateLinksParam(): String {
    return `&activateLinks=${this.activateLinks}`;
  }

  toString(): String {
    return super.toString() + this.apiTypeParam + this.sportTypeParam + this.entityTypeParam + this.entityIdParam + this.sectionNamesParam + this.activateLinksParam;
  }

  equals(model: EntityDescriptionRequestParams): * {
    let equals: Boolean = super.equals(model);

    equals &= this.apiTypeParam === model.apiTypeParam;
    equals &= this.sportTypeParam === model.sportTypeParam;
    equals &= this.entityTypeParam === model.entityTypeParam;
    equals &= this.entityIdParam === model.entityIdParam;
    equals &= this.sectionNamesParam === model.sectionNamesParam;
    equals &= this.activateLinksParam === model.activateLinksParam;

    return equals;
  }
}
